import { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { axiosInstance } from 'utils';
import { useAppDispatch, fetchProfile } from 'store';

function useLogin() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const login = async (email: string, password: string) => {
    setIsLoading(true);
    setIsError(false)
    try {
      const response = await axiosInstance.post('/token/', { email: email.toLowerCase(), password });
      dispatch(fetchProfile());
      const accessToken = response.data.access;
      const refreshToken = response.data.refresh;
      Cookies.set("access", accessToken)
      Cookies.set("refresh", refreshToken)

      toast.success('Вы успешно вошли в систему!');
      navigate('/');
      setIsError(false)
    } catch (error) {
      setIsError(true)
      toast.error('Неверный email или пароль!');
    } finally {
      setIsLoading(false);
    }
  };

  const resetError = () => setIsError(false);

  return { login, isLoading, isError, resetError };
}

export default useLogin;
